import React from 'react'

import styled from 'styled-components'

import { Breakpoints } from 'src/utilities/Breakpoints'
import { BrandColors } from 'src/utilities/Colors'

import { Body2, Body3, Paragraph, Title, TitleH4 } from './Typography'
import { Container } from '../partials/Container'
import CopyCard from '../partials/CopyCard'
import DevDocsBar from '../partials/DevDocsBar'
import { Grid, Column } from '../partials/Grid'
import { ResponsiveSectionWrapper } from '../partials/Section'
import SectionHeader, { ISectionHeaderProps } from '../partials/SectionHeader'

const ParkingLotWrapper = styled(ResponsiveSectionWrapper)``

const Tier1Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const defaultSectionHeader: ISectionHeaderProps = {
  titleContent: 'And much more',
  titleAs: 'h2',
  bodyContent:
    'Reduce the time between entering data and identifying errors from hours to milliseconds -- a game-changer for data workflows.',
  bodyMaxWidth: '120ch'
}

export const ParkingLot = ({
  borderColor = BrandColors.black,
  bodyMaxWidth,
  titleMaxWidth,
  callOutbarText,
  sectionHeader = defaultSectionHeader,
  sectionMaxWidth,
  featureSection,
  tier1Data,
  tier2Data
}: {
  borderColor?: string
  bodyMaxWidth?: string
  titleMaxWidth?: string
  callOutbarText?: string
  sectionHeader?: ISectionHeaderProps
  sectionMaxWidth?: string
  featureSection?: React.ReactNode
  tier1Data?: {
    body?: string
    image?: React.ReactNode
    title?: string
  }[]
  tier2Data?: {
    body?: string
    title?: string
  }[]
}) => (
  <ParkingLotWrapper paddingLarge='6.25rem 0' paddingSmall='4rem 0'>
    {sectionHeader && (
      <Container>
        <SectionHeader
          titleContent={sectionHeader.titleContent}
          titleAs={sectionHeader.titleAs}
          bodyContent={sectionHeader.bodyContent}
          marginBottom={sectionHeader.marginBottom}
          bodyMaxWidth={bodyMaxWidth || null}
          titleMaxWidth={titleMaxWidth || null}
          sectionMaxWidth={sectionMaxWidth || null}
        />
      </Container>
    )}

    {featureSection && <Container>{featureSection}</Container>}

    {tier1Data && (
      <Grid
        container
        columns={{
          sm: 2,
          md: 3
        }}
        spacing={{
          sm: 2,
          md: 3
        }}
        margin='0 0 4rem'
      >
        {tier1Data.map((card, index) => (
          <Column key={index}>
            <Tier1Wrapper>
              {card.title && <TitleH4>{card.title}</TitleH4>}
              {card.image && (
                <img src={card.image} alt={card.title} loading='lazy' />
              )}
              {card.body && <Body3>{card.body}</Body3>}
            </Tier1Wrapper>
          </Column>
        ))}
      </Grid>
    )}

    {tier2Data && (
      <Grid
        container
        columns={{
          sm: 2,
          md: 3
        }}
        columnSpacing={{
          sm: 2,
          md: 3
        }}
        rowSpacing={{
          sm: 2,
          md: 4
        }}
      >
        {tier2Data.map((card, index) => (
          <Column key={index}>
            <CopyCard
              title={card.title}
              body={card.body}
              borderColor={borderColor}
            />
          </Column>
        ))}
      </Grid>
    )}

    {callOutbarText && (
      <Container
        style={{
          marginTop: '4rem'
        }}
      >
        <DevDocsBar text={callOutbarText} />
      </Container>
    )}
  </ParkingLotWrapper>
)
